import { render, staticRenderFns } from "./AdminFormOnGosterim.vue?vue&type=template&id=711ec1fc&scoped=true"
import script from "./AdminFormOnGosterim.vue?vue&type=script&lang=js"
export * from "./AdminFormOnGosterim.vue?vue&type=script&lang=js"
import style0 from "./AdminFormOnGosterim.vue?vue&type=style&index=0&id=711ec1fc&prod&lang=scss"
import style1 from "./AdminFormOnGosterim.vue?vue&type=style&index=1&id=711ec1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ec1fc",
  null
  
)

export default component.exports